import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-950 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-6 py-12 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <img 
              src="https://static.readdy.ai/image/98a462c0b3cf6817d49a825bf36d1d13/7f61d7ef13f2d26ba835b52d0afd2fac.png" 
              alt="Ugo Frederick" 
              className="h-10 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm">
              Professional financial advisory services for insurance, investment, retirement, and estate planning.
            </p>
            <div className="flex gap-4 mt-6">
              <a
                href="https://www.linkedin.com/in/ugo-frederick"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-teal-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-xl text-gray-300"></i>
              </a>
              <a
                href="https://www.facebook.com/freddiley"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-teal-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-xl text-gray-300"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Services</h4>
            <div className="space-y-3">
              <div>
                <Link to="/services" className="text-gray-400 hover:text-teal-500 text-sm cursor-pointer">
                  Insurance Advisory
                </Link>
              </div>
              <div>
                <Link to="/services" className="text-gray-400 hover:text-teal-500 text-sm cursor-pointer">
                  Retirement Planning
                </Link>
              </div>
              <div>
                <Link to="/services" className="text-gray-400 hover:text-teal-500 text-sm cursor-pointer">
                  Business and Corporate owned Insurance solutions
                </Link>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-teal-500 text-sm cursor-pointer">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-400 hover:text-teal-500 text-sm cursor-pointer">
                  Frequently Asked Questions
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-teal-500 text-sm cursor-pointer">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/client-portal" className="text-gray-400 hover:text-teal-500 text-sm cursor-pointer">
                  Client Portal
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>info@ugofrederick.com</li>
              <li>(437) 661-5884</li>
              <li>Units 32-34 – 1600 Steeles Ave W</li>
              <li>Concord, ON L4K 4M2</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex flex-col md:flex-row items-center gap-4">
            <p className="text-gray-400 text-sm">
              © Ugo Frederick 2025. All rights reserved.
            </p>
            <div className="flex gap-1 text-gray-400 text-sm">
              <Link to="/terms" className="hover:text-teal-500 cursor-pointer">
                Terms &amp; Conditions
              </Link>
              <span>|</span>
              <Link to="/privacy" className="hover:text-teal-500 cursor-pointer">
                Privacy Policy
              </Link>
              <span>|</span>
              <Link to="/faq" className="hover:text-teal-500 cursor-pointer">
                FAQ
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
